import axios from "axios"
import { create } from "zustand"

export const useCats = create((set, get) => ({
    cats: [],
    columns: [{
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
    }, {
        title: 'Nomi',
        dataIndex: 'name',
        key: 'name',
    }],
    setCat: (cats) => {
        axios.get('/bookcats')
            .then(res => {
                const data = Array.isArray(res.data) ? res.data : [];
                set({ cats: data });
            })
            .catch(err => {
                console.error('Kategoriyalarni yuklab olishda xatolik:', err);
                set({ cats: [] });
            })
    },
    addCat: (cat) => {
        axios.post('/bookcats', cat)
            .then(res => {
                get().setCat();
            })
            .catch(err => {
                console.error('Kategoriya qo\'shishda xatolik:', err);
            })
    },
    removeCat: (_, cat) => {
        axios.delete('/bookcats/' + cat.id)
            .then(res => {
                get().setCat();
            })
            .catch(err => {
                console.error('Kategoriya o\'chirishda xatolik:', err);
            })
    },
    updateCat: (cat) => {
        axios.put('/bookcats/' + cat.id, cat)
            .then(res => {
                get().setCat();
            })
            .catch(err => {
                console.error('Kategoriya taxrirlashda xatolik:', err);
            })
    },
    ed: null,
    setEd: (ed) => {
        set({ ed })
    }
}))